import type React from 'react';

function AsendiaIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 169 169"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Asendia Icon</title>

      <g id="svg1898">
        <rect width="169" height="169" fill="none" />
        <path d="M125.37,31.14c0-5.29,.11-9.65-.04-14-.09-2.67,.27-4.08,3.59-3.98,8.73,.26,17.48,.19,26.21,.03,2.86-.05,3.96,.59,3.95,3.73-.1,44.95-.09,89.89,0,134.84,0,2.96-.83,3.9-3.84,3.84-8.73-.19-17.48-.21-26.21,.01-3.12,.08-3.85-1-3.71-3.87,.21-4.35,.06-8.71,.06-13.45-2.27,.38-3.05,2.28-4.25,3.44-31.75,30.67-99.74,20.1-113.09-37.29-5.09-21.88-2.52-42.91,9.29-62.41C38.53,6.98,93.7-2.09,125.37,31.14Zm-41.88,96.1c25.24-.1,43.12-17.86,43.12-42.85,0-25.09-18.55-43.51-43.55-43.24-24.8,.27-42.99,18.62-43,43.37,0,24.67,18.45,42.82,43.43,42.73Z" />
      </g>
    </svg>
  );
}

export default AsendiaIcon;
